<link rel="shortcut icon" href="#" />
<div class="optum-tech-popup-container">
  <div class="uitk_new_header">
    <div class="stk-container-tabl-header">
      <div class="stk-header-action">
        @if (selectedNode && getIsOpenRequest()) {
        <ng-container class="openRequestAddAllocation">
          <div class="addNotifyOpenReq">
            There is an Open Request for the selected leader in this UCMG. Click
            <span class="linkToProposal" (click)="showRecord(proposalReq)">here</span>
            to see details.
          </div>
        </ng-container>
        }
        <div class="topCardHorizontalFlexbox">
          <div class="topTechLaborHeaders">
            <div>
              <label class="otlValueTitles">Total Optum Tech Labor</label>
              <p class="otlValues">
                {{ availableOTL !== null ? (availableOTL | currency: 'USD':'symbol':'1.0-0') : '$0' }}
              </p>
            </div>
            <div>
              <label class="otlValueTitles">OT Labor allocated</label>
              <p class="otlValues">{{ L1sTotalOT | currency: 'USD':'symbol':'1.0-0' }}</p>
            </div>
            <div>
              <label class="otlValueTitles">Remaining Optum Tech Labor</label>
              <p
                class="otlValues"
                [ngClass]="{
                                              'positive' : remainingOptumLabour > 0,
                                              'negative' : remainingOptumLabour < 0,
                                              }"
              >
                {{ remainingOptumLabour | currency: 'USD':'symbol':'1.0-0' }}
              </p>
            </div>
          </div>
          <!-- top Tech LH -->
          @if (addLeaderFieldAccess) {
          <div class="addLeaderWrapper">
            <div class="addNewLeaderSection">
              <div class="titleColorAndFormat addNewLeaderTitleFormat" style="width: 12%;">Add New Leader</div>
              <div class="searchAndOTLWrapperSpaceFiller pb-2 pt-2" style="width: 80%;">
                <div style="padding-left: 2%;">
                  <div class="mb-1 titleColorAndFormat leaderTitleFormat">Leader</div>
                  <div class="table-search col-auto p-0 me-4">
                    <mat-form-field
                      class="data-filter cd-table-search leaderInputForm"
                      appearance="outline"
                      style="padding: 0px;"
                    >
                      <input
                        [(ngModel)]="searchText"
                        matInput
                        type="text"
                        class="capability-search"
                        (keyup)="filterTree()"
                      />
                      @if (searchText.length > 0) {
                      <button (click)="clearSearch()" class="leaderInputCancel">
                        <mat-icon>cancel</mat-icon>
                      </button>
                      }
                    </mat-form-field>
                  </div>
                  @if (!showHeirarchy) {
                  <ul class="tree">
                    @for (node of filteredDataForSb; track node) {
                    <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: node, level: 1 }"></ng-container>
                    }
                  </ul>
                  }
                </div>
                <div style="padding-right: 3%;">
                  <div class="mb-1 titleColorAndFormat">Optum Tech Labor</div>
                  <mat-form-field class="search-field">
                    <input
                      [(ngModel)]="OTLTextBox"
                      class="capability-search"
                      type="text"
                      matInput
                      placeholder=""
                      (input)="checkIfAddButtonIsDisabled()"
                      (input)="calculateRemainingOnpressOTL(OTLTextBox)"
                      (keypress)="validateIntegerInput($event)"
                    />
                  </mat-form-field>
                </div>
              </div>
              <ng-container>
                <div style="margin-right: 1%; margin-top: 1%;">
                  <div class="tooltip-container">
                    @if (actionTooltipVisible && getIsOpenRequest()) {
                    <div
                      class="action-button-tooltip"
                      [ngClass]="{ 'action-button-tooltip': true }"
                      [style.top.px]="tooltipY"
                      [style.left.px]="tooltipX"
                    >
                      {{ tooltipContent }}
                    </div>
                    }
                  </div>
                  <!-- PRIV ADD Disabled -->
                  <div
                    (mouseenter)="
                      getIsOpenRequest()
                        ? showTooltip($event, 'Open add request already exists for this leader', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if ((addLeaderButtonDisabled && accessCheck) || (accessCheck && isOpenRequest)) {
                    <button
                      class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button add-leader-button-disabled"
                      (click)="AddNewEntry()"
                    >
                      Add
                    </button>
                    }
                  </div>
                  <!-- PRIV ADD not Disabled -->
                  <div
                    (mouseenter)="
                      getIsOpenRequest()
                        ? showTooltip($event, 'Open add request already exists for this leader', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if ((!addLeaderButtonDisabled && accessCheck && !isOpenRequest)) {
                    <button
                      class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
                      (click)="AddNewEntry()"
                    >
                      Add
                    </button>
                    }
                  </div>
                  <!-- Request Add Disabled -->
                  <div
                    (mouseenter)="
                      getIsOpenRequest()
                        ? showTooltip($event, 'Open add request already exists for this leader', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if ((addLeaderButtonDisabled && !accessCheck) || (!accessCheck && isOpenRequest)) {
                    <button
                      class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button add-leader-button-disabled"
                      (click)="requestAllocation('Add')"
                    >
                      Request Allocation
                    </button>
                    }
                  </div>
                  <!-- Request Add not Disabled -->
                  <div
                    (mouseenter)="
                      getIsOpenRequest()
                        ? showTooltip($event, 'Open add request already exists for this leader', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if ((!addLeaderButtonDisabled && !accessCheck && !isOpenRequest)) {
                    <button
                      class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
                      (click)="requestAllocation('Add')"
                    >
                      Request Allocation
                    </button>
                    }
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          }
        </div>
        <!-- topCardHorizontalFlexbox -->
      </div>
      <!--stk-header-action-->
    </div>
    <!-- stk-container-tabl-header -->
  </div>
  <!-- uitk_new_header -->

  @if (!showLoader && filteredData?.length ==0) {
  <div class=" data-title no-data">
    <div class="errorTitle">No Data Available</div>
  </div>
  }
  <div class="stk-table-container">
    @if (showLoader) {
    <div class="d-flex justify-content-center">
      <app-loader> </app-loader>
    </div>
    } @if (!showLoader && filteredData?.length !== 0) {
    <div class="legend-box">
      <div class="box"></div>
      <span class="legend-text">Rollup OT</span>
      <button type="button" class="export-link" (click)="exportToCsv()" aria-label="Download Rollup OT">
        <span
          aria-hidden="true"
          title="Click to Download"
          class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
        ></span>
      </button>
      <span>
        @if (showDeletebutton) {
        <button
          class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
          (click)="bulkDeleteSelectedElements()"
        >
          Delete
        </button>
        }
      </span>
    </div>
    }
    <div class="tableAndAddSearchBoxWrapper">
      <div class="otl-tables-container">
        @for (L1leaders of filteredData; track L1leaders; let i = $index) {
        <div class="otl-table">
          <table mat-table [dataSource]="L1leaders" [multiTemplateDataRows]="true">
            @if (i === 0) {
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            }
            <!-- Load Columns -->
            <ng-container matColumnDef="department_leader">
              <th mat-header-cell *matHeaderCellDef class="department-leader-header fixed-width-cell">
                @if (!expandCollapseAll) {
                <button class="expand-all-button" mat-icon-button (click)="expandAll()">
                  <mat-icon>navigate_next</mat-icon>
                </button>
                } @if (expandCollapseAll) {
                <button class="expand-all-button" mat-icon-button (click)="collapseAll()">
                  <mat-icon>expand_more</mat-icon>
                </button>
                } Department Leader @if (!isfilterapplied) {
                <span [matMenuTriggerFor]="filterMenu" #trigger="matMenuTrigger">
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                </span>
                } @if (isfilterapplied) {
                <span [matMenuTriggerFor]="filterMenu" #trigger="matMenuTrigger">
                  <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                </span>
                }
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="department-leader-cell fixed-width-cell"
                style="border-radius: 4px;"
              >
                <div
                  style="display:flex; align-items: center;"
                  [ngClass]="{
                    'level-1': element.level == 'L1',
                    'level-2': element.level == 'L2',
                    'level-3': element.level == 'L3',
                    'level-4': element.level == 'L4',
                    'level-5': element.level == 'L5',
                    'level-6': element.level == 'L6',
                    'level-7': element.level == 'L7',
                    'level-8': element.level == 'L8'
                  }"
                >
                  @if (shouldShowExpandIcon(element)) {
                  <button class="tableExpandButton" (click)="toggleExpanded(element)">
                    @if (!element.expanded) {
                    <mat-icon class="expand-down-icon" style="z-index: 100px;">navigate_next</mat-icon>
                    } @if (element.expanded) {
                    <mat-icon class="expand-left-icon" alt="Expanded" style="z-index: 100px;">expand_more</mat-icon>
                    }
                  </button>
                  } @if (!element.edit && element.canEdit && accessCheck) {
                  <input
                    type="checkbox"
                    class="table-checkbox"
                    [disabled]="isOpenProposalUpdateDelete(element) || element.isHierarchyMismatch"
                    [(ngModel)]="element.isChecked"
                    (change)="onCheckboxChange(element)"
                  />
                  }
                  <div class="circle" [ngClass]="{ 'extra-margin': !shouldShowExpandIcon(element) }">
                    <span>{{ element.level }}</span>
                  </div>
                  <div style="display: inline-block;">{{ element.Leader_Name }}</div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="OT_Actuals">
              <th mat-header-cell *matHeaderCellDef class="roll-up-optum-tech-header fixed-width-cell">OT Actuals</th>
              <td mat-cell *matCellDef="let element" class="roll-up-optum-tech-cell fixed-width-cell">
                @if (element.Actuals && (element.Actuals !=0 || element.Actuals === null) ) {
                {{ (element.Actuals | currency: 'USD':'symbol':'1.0-0') || '' }}
                } @if (!element.Actuals &&element.totalActuals !=0 ) {
                <span class="font-ot">{{ (element.totalActuals | currency: 'USD':'symbol':'1.0-0') || '' }} </span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="OT_Run_Rate">
              <th mat-header-cell *matHeaderCellDef class="roll-up-optum-tech-header fixed-width-cell">OT Run Rate</th>
              <td mat-cell *matCellDef="let element" class="roll-up-optum-tech-cell fixed-width-cell">
                @if ( element.Run_Rate && element.Run_Rate !=0) {
                {{ (element.Run_Rate | currency: 'USD':'symbol':'1.0-0') || '' }}
                } @if (!element.Run_Rate && element.totalRunRate !=0) {
                <span class="font-ot">{{ (element.totalRunRate | currency: 'USD':'symbol':'1.0-0') || '' }}</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="Optum_Tech_Labour">
              <th mat-header-cell *matHeaderCellDef class="optum-tech-labour-header fixed-width-cell">OT Labor</th>
              <td mat-cell *matCellDef="let element" class="optum-tech-labour-cell fixed-width-cell">
                @if (!element.edit) {
                <span style="font-weight: bold;"
                  >{{ (element.Optum_Tech_Labour | currency: 'USD':'symbol':'1.0-0') || '' }}
                </span>
                } @if (element.edit) {
                <input
                  #otlLabor
                  [(ngModel)]="element.Optum_Tech_Labour"
                  (keypress)="validateIntegerInput($event)"
                  (input)="calculateRemainingOnpressEditAction(element)"
                />
                } @if (element.roll_up_optum_tech !=0 && !element.Optum_Tech_Labour) {
                <span class="font-ot">{{ (element.roll_up_optum_tech | currency: 'USD':'symbol':'1.0-0') || '' }}</span>
                }
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="roll_up_optum_tech">
                  <th mat-header-cell *matHeaderCellDef class="roll-up-optum-tech-header fixed-width-cell"> Roll Up OT </th>
                  <td mat-cell *matCellDef="let element" class="roll-up-optum-tech-cell fixed-width-cell">
                    <ng-container *ngIf="element.roll_up_optum_tech !=0">
                      {{(element.roll_up_optum_tech | currency:'USD':'symbol':'1.0-0') || ''}}
                    </ng-container>
                  </td>
                </ng-container> -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="action-header fixed-width-cell">Action</th>
              <td mat-cell *matCellDef="let element" class="action-cell fixed-width-cell">
                @if (element.canEdit) {
                <span class="edit-screen-icon">
                  <div class="tooltip-container">
                    @if (actionTooltipVisible) {
                    <div
                      class="action-button-tooltip"
                      [ngClass]="{ 'action-button-tooltip': true }"
                      [style.top.px]="tooltipY"
                      [style.left.px]="tooltipX"
                    >
                      {{ tooltipContent }}
                    </div>
                    }
                  </div>
                  <!-- PRIV ROLE edit -->
                  <div
                    (mouseenter)="
                      isOpenProposalUpdateDelete(element)
                        ? showTooltip($event, 'There is already an existing open proposal for this leader', 'action')
                        : element.isHierarchyMismatch
                        ? showTooltip($event, 'There is a mismatch in the leader hierarchy', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if (!element.edit && accessCheck) {
                    <mat-icon
                      class="icon-crud editPencil"
                      (click)="!isOpenProposalUpdateDelete(element) ? editOTL(element) : null"
                      [ngClass]="{
                        'privledge-disabled-button': isOpenProposalUpdateDelete(element) || element.isHierarchyMismatch,
                        editPencil: !isOpenProposalUpdateDelete(element) && !element.isHierarchyMismatch
                      }"
                    >
                      edit
                    </mat-icon>
                    }
                  </div>
                  <!-- Normal User edit-->
                  <div [ngClass]="{ reqActionSpacerPriv: accessCheck, reqActionSpacer: !accessCheck }">
                    <div
                      (mouseenter)="
                        isOpenProposalUpdateDelete(element)
                          ? showTooltip($event, 'There is already an existing open proposal for this leader', 'action')
                          : element.isHierarchyMismatch
                          ? showTooltip($event, 'There is a mismatch in the leader hierarchy', 'action')
                          : hideTooltip('action')
                      "
                      (mouseleave)="hideTooltip('action')"
                      class="rowAction"
                    >
                      @if (!element.edit && !accessCheck) {
                      <img
                        src="/assets/imagesV4/edit.png"
                        class="allocationActionButtons"
                        loading="eager"
                        alt="Edit Icon"
                        [ngClass]="{
                          'privledge-disabled-button':
                            isOpenProposalUpdateDelete(element) || element.isHierarchyMismatch
                        }"
                        (click)="!isOpenProposalUpdateDelete(element) ? editOTLreqAlloc(element) : null"
                      />
                      }
                    </div>
                  </div>
                  <!-- PRIV ROLE save -->
                  @if (element.edit && accessCheck) {
                  <mat-icon class="icon-crud editPencil" (click)="saveOTL(element, i)">save</mat-icon>
                  }
                  <!-- Normal User save -->
                  @if (element.edit && !accessCheck) {
                  <mat-icon class="icon-crud editPencil" (click)="requestAllocation('Update', element)">save</mat-icon>
                  }
                  <!-- PRIV ROLE cancel -->
                  @if (element.edit) {
                  <mat-icon class="icon-crud editPencil" (click)="editOTLreqAlloc(element)">cancel</mat-icon>
                  }
                  <!-- PRIV User delete -->
                  <div
                    (mouseenter)="
                      isOpenProposalUpdateDelete(element)
                        ? showTooltip($event, 'There is already an existing open proposal for this leader', 'action')
                        : element.isHierarchyMismatch
                        ? showTooltip($event, 'There is a mismatch in the leader hierarchy', 'action')
                        : hideTooltip('action')
                    "
                    (mouseleave)="hideTooltip('action')"
                  >
                    @if (!element.edit && accessCheck) {
                    <mat-icon
                      class="mat-icon notranslate material-icons edit-screen-icon deleteTrash"
                      style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                      aria-hidden="true"
                      data-mat-icon-type="font"
                      (click)="!isOpenProposalUpdateDelete(element) ? deleteLeader(element) : null"
                      [ngClass]="{
                        'privledge-disabled-button': isOpenProposalUpdateDelete(element) || element.isHierarchyMismatch,
                        deleteTrash: !isOpenProposalUpdateDelete(element) && !element.isHierarchyMismatch
                      }"
                    >
                      delete
                    </mat-icon>
                    }
                  </div>
                  <!-- Normal User delete -->
                  <div [ngClass]="{ reqActionSpacerPriv: accessCheck, reqActionSpacer: !accessCheck }">
                    <div
                      (mouseenter)="
                        isOpenProposalUpdateDelete(element)
                          ? showTooltip($event, 'There is already an existing open proposal for this leader', 'action')
                          : element.isHierarchyMismatch
                          ? showTooltip($event, 'There is a mismatch in the leader hierarchy', 'action')
                          : hideTooltip('action')
                      "
                      (mouseleave)="hideTooltip('action')"
                      class="rowAction"
                    >
                      @if (!element.edit && !accessCheck) {
                      <img
                        src="/assets/imagesV4/Delete.png"
                        class="allocationActionButtons"
                        loading="eager"
                        alt="Delete Icon"
                        [ngClass]="{
                          'privledge-disabled-button':
                            isOpenProposalUpdateDelete(element) || element.isHierarchyMismatch
                        }"
                        (click)="!isOpenProposalUpdateDelete(element) ? requestAllocation('Delete', element) : null"
                      />
                      }
                    </div>
                  </div>
                  <!-- PRIV User eye-->
                  @if (!element.edit && accessCheck && isOpenProposalUpdateDelete(element)) {
                  <div [ngClass]="{ reqActionSpacer: accessCheck }">
                    <img
                      src="/assets/imagesV4/eye-blue.png"
                      class="allocationActionButtons"
                      loading="eager"
                      alt="Eye Icon"
                      (click)="routeToUpdateDeleteProposal(element)"
                    />
                  </div>
                  }
                  <!-- Normal User eye-->
                  @if (!element.edit && !accessCheck && isOpenProposalUpdateDelete(element)) {
                  <div [ngClass]="{ reqActionSpacer: !accessCheck }">
                    <div (click)="routeToUpdateDeleteProposal(element)" class="blue-ellipse">
                      <img
                        src="/assets/imagesV4/eye.png"
                        class="allocationActionButtons eye-position"
                        loading="eager"
                        alt="Eye Icon"
                      />
                    </div>
                  </div>
                  }
                  <!-- comments-->
                  <div style="justify-items: center;">
                    <mat-icon
                      class="mat-icon notranslate material-icons edit-screen-icon"
                      style="font-size: 1.1rem; cursor: pointer; color: #013B71;"
                      aria-hidden="true"
                      data-mat-icon-type="font"
                      (click)="leaderCommentsOpen(element)"
                    >
                      message
                    </mat-icon>
                  </div>
                  {{ element.Action || '' }}
                </span>
                }
              </td>
            </ng-container>
            <!-- Render all rows -->
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              style="border: 1px solid #D3C9C9 !important;"
            ></tr>
          </table>
        </div>
        }
      </div>
      <!--wrapper  -->
      <!-- Add Leader Component -->
      <div></div>
    </div>
  </div>

  <!-- Justification Popup -->
  <app-modal [maximizable]="true" #JustificationModal class="modal-demo move-top">
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 50%;">
        <div class="">
          <span class="fw-700 justification-modal-label">Justification</span>
        </div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body">
      <div class="d-flex flex-row align-items-center ">
        <div class="justification-label p-2 m-0">
          Justification
        </div>
        <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
      </div>
      <textarea
        class="resizeTextArea"
        type="textarea"
        class="form-control"
        [(ngModel)]="justificationTextfield"
        required
        minlength="3"
        maxlength="330"
      ></textarea>
      <div class="flex-justifcation-applybutton-space">
        <button
          [disabled]="!justificationTextfield || justificationTextfield == ''"
          class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
          (click)="applyJustification()"
        >
          Apply
        </button>
      </div>
    </ng-container>
  </app-modal>
  <app-modal [maximizable]="true" #deleteJustificationModal class="modal-demo move-top deleteJustificationModal">
    <ng-container class="app-modal-header">
      <div style="display: flex;width: 50%;">
        <div class="">
          <span class="fw-700 justification-modal-label">Justification</span>
        </div>
      </div>
    </ng-container>
    <ng-container class="app-modal-body">
      <div class="deleteAllocJustificationTFContainerFlex">
        <div class="deleteAllocJustificationTFContainer">
          <div class="d-flex flex-row align-items-center ">
            <div class="justification-labelDeleteAlloc p-2 m-0">
              Justification
            </div>
            <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
          </div>
          <textarea
            class="resizeTextArea"
            type="textarea"
            class="form-control"
            [(ngModel)]="justificationTextfield"
            required
            minlength="3"
            maxlength="330"
          ></textarea>
        </div>
      </div>
      <div class="flex-justifcation-applybutton-space">
        <button
          [disabled]="!justificationTextfield"
          class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u_margin-right--base uitk-u-margin-bottom--xs techops-global-button"
          (click)="applyDeleteJustification()"
        >
          Continue
        </button>
        <button
          class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
          (click)="closeDeleteJustificationModal()"
        >
          Cancel
        </button>
      </div>
    </ng-container>
  </app-modal>
</div>
<!-- optum popup -->

<!-- template for sreach box -->

<!-- recursive tree template -->
<ng-template #renderNode let-node let-level="level">
  <li>
    <div class="tooltip-container">
      @if (leaderTooltipVisible) {
      <div
        class="leaderhier-tooltip"
        [ngClass]="{ 'leaderhier-tooltip': true }"
        [style.top.px]="tooltipY"
        [style.left.px]="tooltipX"
      >
        {{ tooltipContent }}
      </div>
      }
    </div>
    <div
      (mouseenter)="
        leaderHierMouseEnterTooltipLogic(node)
          ? showTooltip($event, this.tooltipContent, 'leader')
          : hideTooltip('leader')
      "
      (mouseleave)="hideTooltip('leader')"
      [class.exsist]="isDisabled(node)"
      class="node-content level-{{ level }}"
      [ngClass]="{ 'ps-4': node.children?.length == 0, 'ms-3': node.children?.length == 0 }"
    >
      @if (node.children?.length) {
      <button mat-icon-button (click)="toggleNode(node)" class="h-auto">
        <mat-icon>{{ isExpanded(getNodeId(node)) ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>
      }
      <span class="circle m-0">L{{ level }}</span>
      <span
        [innerHTML]="highlightText(getLeaderName(node))"
        (click)="onSelectNode(node)"
        [class.selected]="isSelected(node)"
      ></span>
    </div>
    @if (isExpanded(getNodeId(node))) {
    <ul>
      @for (child of node.children; track child) {
      <ng-container *ngTemplateOutlet="renderNode; context: { $implicit: child, level: level + 1 }"></ng-container>
      }
    </ul>
    }
  </li>
</ng-template>

<mat-menu #filterMenu="matMenu">
  <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <input matInput type="text" class="searchoption" [(ngModel)]="searchFilterText" placeholder="Search Leader" />
    <mat-selection-list class="filter-list-container" [disableRipple]="true" [(ngModel)]="selectedFilters">
      @for (leader of leaderNames | search: searchFilterText; track leader) {
      <mat-list-option checkboxPosition="before" [value]="leader">
        {{ leader }}
      </mat-list-option>
      }
    </mat-selection-list>
    <span
      style="cursor:pointer; float: right; padding-right: 70px;"
      class="small localApplyButton"
      (click)="applyLocalFilter()"
      >Apply</span
    >
    <span
      style="cursor:pointer; float: right; padding-right: 22px;"
      class="small localApplyButton"
      (click)="clearLocalFilter()"
      >Clear</span
    >
  </div>
</mat-menu>

<!-- Proposal Request pop-up -->
<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalRoot
  class="modal-demo req-details-popup"
  (closeModal)="onModalClose()"
>
  <ng-container class="app-modal-header"
    >Request ID : {{ proposalReq?.Request_Id }} | Status : {{ proposalReq?.Req_Status }}</ng-container
  >
  <ng-container class="app-modal-body">
    <app-proposal-popup
      [propDataSource]="proposalReq"
      [selectedRequestId]="proposalReq?.Request_Id"
      (hidePopup)="hidecancelpopup()"
      [selectedOption]="proposalPopupSelectedOption"
      [closedProposalPopup]="closedProposalPopup"
    ></app-proposal-popup>
  </ng-container>
</app-modal>

<!-- Leader Comments pop-up -->
<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #leaderComments
  class="modal-demo req-details-popup"
  (closeModal)="leaderCommentsClose()"
>
  <ng-container class="app-modal-header">{{ ucmgId }} - {{ ucmgName }} | {{ leaderCommentsHeaderName }}</ng-container>
  <ng-container class="app-modal-body">
    <!-- COMMENTS -->
    @if (accessCheck) {
    <div class="d-flex flex-column justify-content-left align-items-center">
      <div class="d-flex" style="width: 80%;">
        <div class="commentTextBoxContainer pb-3">
          <div class="form-inline-new" style="align-content: center; width: 100%;">
            <p class="comments-font">Enter Comment</p>
          </div>
          <div class="comments-edit">
            <textarea
              class="comments-add-input comments-border comments-textfield"
              [(ngModel)]="comments"
              maxlength="300"
              cols="100"
              rows="4"
            ></textarea>
          </div>
        </div>
        <ng-container>
          <button
            class="stk-action-add add-margin m-1 me-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button"
            style="align-self: center;"
            [disabled]="!comments || comments.trim() === ''"
            (click)="leaderCommentsAdd()"
          >
            Add
          </button>
        </ng-container>
      </div>
    </div>
    }

    <!-- TAbLE -->
    <div class="leaderCommentsParentContainer">
      @if (!isLeaderCommentsDataNull) {
      <ng-container class="leaderCommentsTable">
        <app-maintenance-table-v4
          [TABLE_CONFIG]="LEADER_COMMENTS_CONFIG"
          [COLUMNS]="LEADER_COMMENTS_COLUMNS"
          [dataSource]="leaderCommentsData"
          [pageSize]="LEADER_COMMENTS_CONFIG.pageSize"
          [pageIndex]="LEADER_COMMENTS_CONFIG.pageIndex"
          style="width: 80%;"
          class="leaderCommentsTable"
        >
        </app-maintenance-table-v4>
      </ng-container>
      } @else {
      <div class="no-data-available" style="text-align: center;">
        <div class="no-records-found">
          <div class="img-align">
            <img class="image-align" src="/assets/images/warning-icon.svg" />
          </div>
          <div class="data-title">
            <div class="errorTitle">No Data Available</div>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-container>
</app-modal>
